(function() {
  const init = function() {
    if (!window.customElements.get("announcement-bar")) {
      var AnnouncementBar = class extends CustomHTMLElement {
        async connectedCallback() {
          await customElements.whenDefined("announcement-bar-item");
          this.items = Array.from(this.querySelectorAll("announcement-bar-item"));
          this.hasPendingTransition = false;
          this.delegate.on("click", '[data-action="prev"]', this.previous.bind(this));
          this.delegate.on("click", '[data-action="next"]', this.next.bind(this));
          if (this.autoPlay) {
            this.delegate.on("announcement-bar:content:open", this._pausePlayer.bind(this));
            this.delegate.on("announcement-bar:content:close", this._startPlayer.bind(this));
          }
          if (window.ResizeObserver) {
            this.resizeObserver = new ResizeObserver(this._updateCustomProperties.bind(this));
            this.resizeObserver.observe(this);
          }
          if (this.autoPlay) {
            this._startPlayer();
          }
          if (Shopify.designMode) {
            this.delegate.on("shopify:block:select", (event) => this.select(event.target.index, false));
          }
        }
        get autoPlay() {
          return this.hasAttribute("auto-play");
        }
        get selectedIndex() {
          return this.items.findIndex((item) => item.selected);
        }
        previous() {
          this.select((this.selectedIndex - 1 + this.items.length) % this.items.length);
        }
        next() {
          this.select((this.selectedIndex + 1 + this.items.length) % this.items.length);
        }
        async select(index, animate = true) {
          if (this.selectedIndex === index || this.hasPendingTransition) {
            return;
          }
          if (this.autoPlay) {
            this._pausePlayer();
          }
          this.hasPendingTransition = true;
          await this.items[this.selectedIndex].deselect(animate);
          await this.items[index].select(animate);
          this.hasPendingTransition = false;
          if (this.autoPlay) {
            this._startPlayer();
          }
        }
        _pausePlayer() {
          clearInterval(this._interval);
        }
        _startPlayer() {
          this._interval = setInterval(this.next.bind(this), parseInt(this.getAttribute("cycle-speed")) * 1e3);
        }
        _updateCustomProperties(entries) {
          entries.forEach((entry) => {
            if (entry.target === this) {
              const height = entry.borderBoxSize ? entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.borderBoxSize.blockSize : entry.target.clientHeight;
              document.documentElement.style.setProperty("--announcement-bar-height", `${height}px`);
            }
          });
        }
      };
      
      window.customElements.define("announcement-bar", AnnouncementBar);
    }
    if (!window.customElements.get("announcement-bar--secondary")) {
      var AnnouncementBarSecondary = class extends AnnouncementBar {
        connectedCallback() {
          super.connectedCallback();
          this.initializeCountdown();

          if (Shopify.designMode) {
            this.delegate.on("shopify:section:load", () => this.initializeCountdown());
          }
        }

        initializeCountdown() {
          this.countdownElements = this.querySelectorAll(".announcement-bar__countdown");
          this.countdownElements.forEach((countdownElement) => {
            countdown(
              new Date(countdownElement.dataset.date),
              function(ts) {
                countdownElement.innerHTML = ts.toHTML();
              },
              countdown.MONTHS | countdown.DAYS | countdown.HOURS | countdown.MINUTES | countdown.SECONDS
            );
          });
        }
        // Overwrite _updateCustomProperties, because secondary announcement bar is not sticky
        _updateCustomProperties() {}
      };

      window.customElements.define("announcement-bar--secondary", AnnouncementBarSecondary);
    }
    if (!window.customElements.get("announcement-bar-item")) {
      var AnnouncementBarItem = class extends CustomHTMLElement {
        connectedCallback() {
          if (this.hasContent) {
            this.contentElement = this.querySelector(".announcement-bar__content");
            this.delegate.on("click", '[data-action="open-content"]', this.openContent.bind(this));
            this.delegate.on("click", '[data-action="close-content"]', this.closeContent.bind(this));
            if (Shopify.designMode) {
              this.addEventListener("shopify:block:select", this.openContent.bind(this));
              this.addEventListener("shopify:block:deselect", this.closeContent.bind(this));
            }
          }
        }
        get index() {
          return [...this.parentNode.children].indexOf(this);
        }
        get hasContent() {
          return this.hasAttribute("has-content");
        }
        get selected() {
          return !this.hasAttribute("hidden");
        }
        get focusTrap() {
          return this._trapFocus = this._trapFocus || window.createFocusTrap(this.contentElement.querySelector(".announcement-bar__content-inner"), {
            fallbackFocus: this,
            clickOutsideDeactivates: (event) => !(event.target.tagName === "BUTTON"),
            allowOutsideClick: (event) => event.target.tagName === "BUTTON",
            onDeactivate: this.closeContent.bind(this),
            preventScroll: true
          });
        }
        async select(animate = true) {
          this.removeAttribute("hidden");
          await new Promise((resolve) => {
            this.animate({
              transform: ["translateY(8px)", "translateY(0)"],
              opacity: [0, 1]
            }, {
              duration: animate ? 150 : 0,
              easing: "ease-in-out"
            }).onfinish = resolve;
          });
        }
        async deselect(animate = true) {
          await this.closeContent();
          await new Promise((resolve) => {
            this.animate({
              transform: ["translateY(0)", "translateY(-8px)"],
              opacity: [1, 0]
            }, {
              duration: animate ? 150 : 0,
              easing: "ease-in-out"
            }).onfinish = resolve;
          });
          this.setAttribute("hidden", "");
        }
        async openContent() {
          if (this.hasContent && this.contentElement) {
            this.contentElement.addEventListener("transitionend", () => this.focusTrap.activate(), { once: true });
            this.contentElement.removeAttribute("hidden");
            document.documentElement.classList.add("lock-all");
            this.dispatchEvent(new CustomEvent("announcement-bar:content:open", { bubbles: true }));
          }
        }
        async closeContent() {
          if (!this.hasContent || !this.contentElement || this.contentElement.hasAttribute("hidden")) {
            return Promise.resolve();
          }
          await new Promise((resolve) => {
            this.contentElement.addEventListener("transitionend", () => resolve(), { once: true });
            this.contentElement.setAttribute("hidden", "");
            this.focusTrap.deactivate();
            document.documentElement.classList.remove("lock-all");
            this.dispatchEvent(new CustomEvent("announcement-bar:content:close", { bubbles: true }));
          });
        }
      };
      
      window.customElements.define("announcement-bar-item", AnnouncementBarItem);
    }
  }
  if (window.criticalLoaded) { init() }
  else { document.addEventListener("critical-js:loaded", init); }
})();